var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.922,
    height: 8.875,
    viewBox: "0 0 14.922 8.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-Right",
    transform: "translate(23.508 -5.586) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_585",
    "data-name": "Trazado 585",
    d: "M0,0,6.047,6.047,12.094,0",
    transform: "translate(7 22.094) rotate(-90)",
    fill: "none",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrigger);
export default __webpack_public_path__ + "static/media/arrowTrigger.0bea37d13f90a0b7a58a000ad55df9eb.svg";
export { ForwardRef as ReactComponent };